import SajuMyungsikData from "@DataDefine/saju_myungsik_data";
import { SajuInfoModel } from "@DataDefine/saju_info_model";
import { JeomsinUserInfo } from "@DataDefine/jeomsin_user_info";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { getDeviceId } from "@Config/jeomsin_application_info";
import { useUserInfoStore } from "@State/user_info_store";

interface ZTracking {
    pageViewId?:string;
    pageViewTitle?:string;
    popupViewTitle?:string;
    backupPageViewId?:string;
    backupPageViewTitle?:string;
    setPageViewInfo: (id?: string, title?: string) => void;
    setBackupPageViewInfo: (id?: string, title?: string) => void;
    restorePageViewInfo: () => void;
    setPopupViewTitle: (title?: string) => void;
    setUserInfo: (userList:JeomsinUserInfo[], memNo?:string) => void;
    removeUserInfo:() => void;
    checkProperties: () => void;
    setTrackingProperties:(userList?:JeomsinUserInfo[], memNo?:string) => void;
    getSajuNames:(sajuInfo:SajuInfoModel) => string[];
}
  
const useTrackingStore = create(
    persist<ZTracking>(
        (set, get) => ({
            pageViewId: undefined,
            pageViewTitle: undefined,
            popupViewTitle:undefined,
            backupPageViewId: undefined,
            backupPageViewTitle: undefined,
            setPageViewInfo: (id?: string, title?: string) => {
                set({
                    pageViewId: id,
                    pageViewTitle: title
                })
            },
            setBackupPageViewInfo: (id?: string, title?: string) => {
                set({
                    backupPageViewId: get().pageViewId,
                    backupPageViewTitle: get().pageViewTitle,
                    pageViewId: id,
                    pageViewTitle: title,
                })
            },
            restorePageViewInfo: () => {
                set({
                    pageViewId: get().backupPageViewId,
                    pageViewTitle: get().backupPageViewTitle,
                    backupPageViewId: undefined,
                    backupPageViewTitle: undefined,
                })
            },
            setPopupViewTitle: (title?: string) => {
                set({
                    popupViewTitle: title
                })
            },
            setUserInfo: (userList?:JeomsinUserInfo[], memNo?:string) => {
                get().setTrackingProperties(userList, memNo);
            },
            removeUserInfo:() => {
                get().setTrackingProperties();
            },
            checkProperties:() => {
                get().setTrackingProperties(useUserInfoStore.getState().userInfoList, useUserInfoStore.getState().loginMemberInfo?.mem_info?.mem_no);
            },
            setTrackingProperties:(userList?:JeomsinUserInfo[], memNo?:string) => {

                if(userList && userList?.length > 0) {
                    // console.log(`gaTag setTrackingProperties`);
                    const myInfo = userList[0];
                    const sajuNames = myInfo.saju_info ? get().getSajuNames(myInfo.saju_info) : ["","","",""];

                    const gTag = (window as any).gtag;
                    if(gTag) {
                        gTag("set", "user_properties", {
                            user_id: `${getDeviceId()}`,
                            gender: myInfo.gender === "0" ? "male" : "female",
                            birth_year: myInfo.birthYear,
                            year_pillar: sajuNames[0],
                            month_pillar: sajuNames[1],
                            day_pillar: sajuNames[2],
                            hour_pillar: sajuNames[3],
                            user_grade: memNo ? "회원" : "비회원",
                            user_no: memNo ? memNo : "",
                        });
                    }

                } else { //undfined
                    // console.log(`gaTag setGuestTrackingProperties`);
                    const gTag = (window as any).gtag;
                    if(gTag) {
                        gTag("set", "user_properties", {
                            user_id: `${getDeviceId()}`,
                            gender: "",
                            birth_year: "",
                            year_pillar: "",
                            month_pillar: "",
                            day_pillar: "",
                            hour_pillar: "",
                            user_grade: "",
                            user_no: "",
                        });
                    }
                }
            },
            getSajuNames: (sajuInfo:SajuInfoModel):string[] => {
                const sajuMyungsikDatas = SajuMyungsikData();
                
                const length = sajuInfo.chunganJijiOhangNodes.length;
                const sajuNames:string[] = []; //[시주, 일주, 월주, 년주]
                sajuInfo.chunganJijiOhangNodes.forEach((value, index) => {
                    if(index < length/2) { //사주 첫글자
                        sajuNames.push(sajuMyungsikDatas.birthChunganData[value.num].classTitle);
                    } else {
                        const pos = index - length/2;
                        sajuNames[pos] = sajuNames[pos] + sajuMyungsikDatas.birthJijiData[value.num].classTitle;
                    }
                });

                return sajuNames;
            }
        }),
        { 
            name: 'tracking-storage',
            storage: createJSONStorage(() => sessionStorage) //탭 종료 시 스토리지에 저장된 데이터 Clear
        }
    )
);

export default useTrackingStore;